// hooks/useDebounce.js
import { useState, useEffect, useRef } from 'react';

const useDebounce = (serviceFunction, delay = 300) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isAPICalled, setIsAPICalled] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (!searchTerm || searchTerm.length < 3) {
      setResults([]);
      setIsAPICalled(false);
      return;
    }

    // Set new timeout
    timeoutRef.current = setTimeout(async () => {
      try {
        setIsLoading(true);
        const data = await serviceFunction({ address: searchTerm });
        setResults(data);
        setIsAPICalled(true);
      } catch (error) {
        console.error('Error fetching data:', error);
        setResults([]);
      } finally {
        setIsLoading(false);
      }
    }, delay);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [searchTerm, delay, serviceFunction]);

  return {
    searchTerm,
    setSearchTerm,
    results,
    isLoading,
    isAPICalled,
    clearResults: () => {
      setResults([]);
      setIsAPICalled(false);
    },
  };
};

export default useDebounce;
